<template>
    <div id="app">
        <ejs-tab id="element" ref='unitsTab'>
            <e-tabitems>
                <e-tabitem :header='headerText1' :content='tradingTemplate'></e-tabitem>
                <e-tabitem :header='headerText2' :content='volumeTemplate'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import tradingForm from '@/views/administration/units/TradingUnit.vue';
    import volumeForm from '@/views/administration/units/VolumeUnit.vue';
    
    import { DatePickerComponent, CalendarComponent, DatePickerPlugin, CalendarPlugin } from '@syncfusion/ej2-vue-calendars';

    Vue.use(TabPlugin);
    Vue.use(TabPlugin);
    Vue.component(DatePickerPlugin.name, DatePickerComponent);
    Vue.component(CalendarPlugin.name, CalendarComponent);

    export default {
        name: 'app',
        data: function () {
            return {
                headerText1: { text: 'Trading' },
                headerText2: { text: 'Volume' },
                propsData: null,
                tradingTemplate: function () {
                    return {
                        template: {
                            extends: tradingForm
                        }
                    }
                },
                volumeTemplate: function () {
                    return {
                        template: {
                            extends: volumeForm
                        }
                    }
                },
            }
        },
        mounted: function () {
            if (!this.$store.state.permissions["Permissions.TradingUnits.View"]) {
                this.$refs.unitsTab.hideTab(0);
            }
            if (!this.$store.state.permissions["Permissions.VolumeUnits.View"]) {
                this.$refs.unitsTab.hideTab(1);
            }
        },
    }
</script>

<style scoped>
</style>